/* eslint-disable react-hooks/exhaustive-deps */
import { AxiosResponse } from "axios";
import { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import useMultiLanguage from "../../hook/useMultiLanguage";
import Autocomplete from "../components/input/autocomplete";
import InputSearch from "../components/input/InputSearch";
import TextValidator from "../components/input/text-validator";
import TableCollapseCustom, { columnNamesCollapseType } from "../components/table-collapse-custom/TableCollapseCustom";
import { RESPONSE_STATUS_CODE, VARIABLE_STRING } from "../constants/moduleConsts";
import "./warning.scss";
import { WarningChart } from "./components/WarningChart";
import { canhBaoHetHanHopDongColumn } from "./components/columns/canhBaoHetHanHopDongColumn";
import { canhBaoHetHanNangLuongColumn } from "./components/columns/canhBaoHetHanNangLuongColumn";
import {
  EXPIRE_STATUS_KEY,
  TYPE_CHART,
  WARNING,
  chartHeight,
  chartOptions,
  chartType,
  infoTextColorLabel,
  infoTextKey,
  infoTextLabel,
  totalKey,
  warningId,
  warningPrefix,
  warningTitle
} from "./constants/warningConsts";
import { IAdjustSalary, IDataSeries, IParams, IRetireInfo, IWarning, IWarningStatus } from "./models/warningModels";
import {
  getDataCanhBaoDenHanVanBangChungChi,
  getDataCanhBaoHetHanGianDoan,
  getDataCanhBaoHetHanHopDong,
  getDataCanhBaoHetHanLuanChuyen,
  getDataCanhBaoHetHanNangLuong,
  getDataCanhBaoHetHanDaoTao,
  getDataCanhBaoNangLuongTruocHan,
  getDataCanhBaoNhanSuDenTuoiNghiHuu,
  getDataWarning,
  getNghiViecChamDutHopDong
} from "./services/warningServices";
import { AdjustSalaryDialog } from "./components/dialogs/AdjustSalaryDialog";
import { canhBaoNhanSuDenTuoiNghiHuu } from "./components/columns/canhBaoNhanSuDenTuoiNghiHuu";
import { RetireDecisionDialog } from "./components/dialogs/RetireDecisionDialog";
import { canhBaoDenHanVanBangChungChi } from "./components/columns/canhBaoDenHanVanBangChungChi";
import AppContext from "../../AppContext";
import moment from "moment";
import { ContractDialog } from "../profile/components/dialogs/ContractDialog";
import { IContractInfo } from "../contract/models/contractModels";
import { getEmployeeProfileById } from "../profile/services/profileServices";
import { convertDataUI as convertEmployeeInfo } from "../profile/utils/profileUtils";
import EndContractDialog from "./components/dialogs/EndContractDialog";
import { ResignInfo } from "../resign/models/resignModels";
import { canhBaoHetHanLuanChuyenColumn } from "./components/columns/canhBaoHetHanLuanChuyenColumn";
import TransitionWarningDialog from "./components/dialogs/TransitionWarningDialog";
import { TransitionInFo } from "../transition/models/transitionModels";
import { removeDiacritics } from "../utils/functionUtils";
import { canhBaoNangLuongTruocHanColumn } from "./components/columns/canhBaoNangLuongTruocHanColumn";
import { SalaryAheadOfTimeDialog } from "./components/dialogs/SalaryAheadOfTimeDialog";
import { GroupButton } from "../components/GroupButton";
import { searchListWorkUnit } from "../services/services";
import { canhBaoHetHanGianDoanColumn } from "./components/columns/canhBaoHetHanGianDoanColumn";
import { canhBaoHetHanCuDaoTaoColumn } from "./components/columns/canhBaoHetHanCuDaoTaoColumn";
import { CertificateTrainingDialog } from "./components/dialogs/CertificateTrainingDialog";

function Warning() {
  const { lang } = useMultiLanguage();
  const { setPageLoading } = useContext(AppContext);

  const [isViewDetails, setIsViewDetails] = useState<boolean>(false);
  const [isViewAll, setIsViewAll] = useState<boolean>(true);
  const [dataChart, setDataChart] = useState<any>();
  const [dataWarningDetails, setDataWarningDetails] = useState<any[]>([]);
  const [listWarning, setListWarning] = useState<IWarning[]>([]);
  const [columns, setColumns] = useState<columnNamesCollapseType[]>([]);
  const [title, setTitle] = useState<string>("");
  const [salaryInfo, setSalaryInfo] = useState<IAdjustSalary>({} as IAdjustSalary);
  const [isOpenAdjustSalaryDialog, setIsOpenAdjustSalaryDialog] = useState<boolean>(false);
  const [retireInfo, setRetireInfo] = useState<IRetireInfo>({} as IRetireInfo);
  const [isOpenRetireDialog, setIsOpenRetireDialog] = useState<boolean>(false);
  const [currentDetail, setCurrentDetail] = useState("");
  const [isOpenAddContractDialog, setIsOpenAddContractDialog] = useState<boolean>(false);
  const [isOpenEndContractDialog, setIsOpenEndContractDialog] = useState<boolean>(false);
  const [isOpenTransitionDialog, setIsOpenTransitionDialog] = useState<boolean>(false);
  const [isOpenSalaryAheadOfTimeDialog, setIsOpenSalaryAheadOfTimeDialog] = useState<boolean>(false);
  const [isOpenCertificateDialog, setIsOpenCertificateDialog] = useState<boolean>(false);
  const [employeeInfo, setEmployeeInfo] = useState<any>({});
  const [initContract, setInitContract] = useState<IContractInfo>({} as IContractInfo);
  const [endResignInfo, setEndResignInfo] = useState<ResignInfo | null>(null);
  const [curWarningInfo, setCurWarningInfo] = useState<any>({});
  const [searchObject, setSearchObject] = useState<any>({
    donVi: null,
    orgId: "",
    keyword: null,
    requestDate: moment().format("YYYY-MM-DD")
  });

  const fetchDataWarning = async (params: IParams = searchObject) => {
    try {
      setPageLoading(true);
      let { data } = await getDataWarning(params);
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        setDataChart(data?.data);
      } else {
        toast.warning(data?.message);
      }
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    } finally {
      setPageLoading(false);
    }
  };

  const getCanhBao = async (fetchFunc: (data: IParams) => Promise<AxiosResponse<any>>, expireStatusKey: string, searchParam: IParams = searchObject) => {
    try {
      setPageLoading(true);
      let { data } = await fetchFunc(searchParam);
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        let _data = data?.data?.map((item: any) => ({
          ...item,
          data: item?.data?.map((subItem: any) => ({
            ...subItem,
            [expireStatusKey]: {
              ...subItem[expireStatusKey],
              bgColor: checkColorCanhBao({ ...subItem[expireStatusKey] })
            }
          }))
        }));
        setDataWarningDetails(_data);
      } else {
        toast.warning(data?.message);
      }
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    if (!dataChart) return;
    const listChart = convertDataChart(dataChart);
    if(!searchObject.keyword) {
      setListWarning(listChart);
      return;
    }
    setListWarning(listChart.filter((chart: any) => 
      removeDiacritics(chart.title).includes(removeDiacritics(searchObject.keyword))
    ));
  }, [dataChart, isViewAll]);

  const convertChartOptions = (chartOptions: any, typeChart: string, dataSeries: IDataSeries[]) => {
    switch (typeChart) {
      case TYPE_CHART.DONUT:
        return {
          ...chartOptions,
          series: [
            {
              ...chartOptions.series[0],
              data: dataSeries
            }
          ]
        };
      default:
        return chartOptions;
    }
  };

  const convertDataChart = (dataChart: IWarning) => {
    if (!dataChart) return [];
    let result: IWarning[] = [];
    warningPrefix.forEach((prefix, index) => {
      let obj: any = {};
      let dataChartObj: any = {};
      Object.keys(dataChart).forEach((key) => {
        obj.title = warningTitle[index];
        obj.id = warningId[index];
        if (key.startsWith(prefix) && key !== totalKey[index]) {
          dataChartObj[key] = dataChart[key as keyof Pick<IWarning, "value">];
        }
      });
      let _dataInfoText = infoTextKey[index].map((key, idx) => ({
        key: key,
        name: infoTextLabel[index][idx],
        value: dataChart[key as keyof Pick<IWarning, "value">],
        colorLabel: infoTextColorLabel[index][idx]
      }));
      let _dataSeries: IDataSeries[] = infoTextKey[index]
        .filter((key) => key !== totalKey[index])
        .map((key, idx) => ({
          name: infoTextLabel[index][idx],
          value: dataChart[key as keyof Pick<IWarning, "value">]
        }));
      result.push({
        ...obj,
        dataInfoText: _dataInfoText,
        type: chartType[index],
        options: convertChartOptions(chartOptions[index], chartType[index], _dataSeries),
        height: chartHeight[index]
      });
    });

    if (!isViewAll) {
      result = result.filter((item: any) => item?.dataInfoText?.some((dataInfo: any) => dataInfo.value))
    }

    return result;
  };

  const checkColorCanhBao = (status: IWarningStatus) => {
    switch (status.code) {
      case WARNING.STATUS.CODE.GAN_DEN_HAN:
        return "bg-green";
      case WARNING.STATUS.CODE.DEN_HAN:
        return "bg-dark-orange";
      case WARNING.STATUS.CODE.QUA_HAN:
        return "bg-dark-red";
      default:
        break;
    }
  };

  useEffect(() => {
    fetchDataUnit();
  }, []);

  const fetchDataUnit = async () => {
    try {
      let { data } = await searchListWorkUnit();
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        const unitDefault = data?.data?.content?.[0];
        const _searchObject = {
          ...searchObject,
          donVi: unitDefault || null,
          orgId: unitDefault?.id || ""
        };
        setSearchObject(_searchObject);
        await fetchDataWarning(_searchObject);
      } else {
        toast.warning(data?.message);
      }
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    }
  };

  const handleAdjustSalary = (row: IAdjustSalary) => {
    setSalaryInfo(row);
    setIsOpenAdjustSalaryDialog(true);
  };

  const handleDecideToRetire = (row: any) => {
    setRetireInfo(row);
    setIsOpenRetireDialog(true);
  };

  const handleReSignContract = async (row: any) => {
    try {
      setPageLoading(true);
      setCurWarningInfo(row);
      const { data } = await getEmployeeProfileById(row?.employeeId || "");
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        const employeeInfoConverted = convertEmployeeInfo(data?.data || {});
        const initContract = {
          employee: employeeInfoConverted,
          employeeCode: employeeInfoConverted?.code,
          phongBan: employeeInfoConverted?.phongBan,
          chucVu: employeeInfoConverted?.chucVu,
          chucDanh: employeeInfoConverted?.viTriCongViec,
          loaiCanBo: employeeInfoConverted?.loaiCanBo,
          tenNguoiLaoDong: employeeInfoConverted?.name,
          employeeId: employeeInfoConverted?.id
        };
        await setEmployeeInfo(employeeInfoConverted);
        await setInitContract(initContract as IContractInfo);
        setIsOpenAddContractDialog(true);
      } else {
        toast.warning(data?.message);
      }
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    } finally {
      setPageLoading(false);
    }
  };

  const handleEndContract = async (row: any) => {
    setCurWarningInfo(row);
    try {
      setPageLoading(true);
      const { data } = await getNghiViecChamDutHopDong(row?.employeeId);
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) { 
        setEndResignInfo(data?.data || null);
      } else {
        toast.warning(data?.message);
      }
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    } finally {
      setPageLoading(false);
    }
    setIsOpenEndContractDialog(true);
  };

  const handleAddTransition = (row: any) => {
    setCurWarningInfo(row);
    setIsOpenTransitionDialog(true);
  }

  const handleSalaryAheadOfTime = (row: IAdjustSalary) => {
    setSalaryInfo(row);
    setIsOpenSalaryAheadOfTimeDialog(true);
  };

  const handleCloseSalaryAheadOfTimeDialog = () => {
    setSalaryInfo({} as IAdjustSalary);
    setIsOpenSalaryAheadOfTimeDialog(false);
  };

  const handleAddCertificate = (row: any) => {
    setCurWarningInfo(row);
    setIsOpenCertificateDialog(true);
  }

  const handleOpenDetails = (idWarning: string, title: string) => {
    const _searchObject = {
      ...searchObject,
      keyword: null
    };
    setSearchObject(_searchObject);
    switch (idWarning) {
      case VARIABLE_STRING.CANH_BAO_HET_HAN_HOP_DONG:
        getCanhBao(getDataCanhBaoHetHanHopDong, EXPIRE_STATUS_KEY.HET_HAN_HOP_DONG, _searchObject);
        setColumns(canhBaoHetHanHopDongColumn(handleReSignContract, handleEndContract));
        setCurrentDetail(VARIABLE_STRING.CANH_BAO_HET_HAN_HOP_DONG);
        break;
      case VARIABLE_STRING.CANH_BAO_DEN_HAN_NANG_LUONG:
        getCanhBao(getDataCanhBaoHetHanNangLuong, EXPIRE_STATUS_KEY.DEN_HAN_NANG_LUONG, _searchObject);
        setColumns(canhBaoHetHanNangLuongColumn(handleAdjustSalary));
        setCurrentDetail(VARIABLE_STRING.CANH_BAO_DEN_HAN_NANG_LUONG);
        break;
      case VARIABLE_STRING.CANH_BAO_NHAN_SU_DEN_TUOI_NGHI_HUU:
        getCanhBao(getDataCanhBaoNhanSuDenTuoiNghiHuu, EXPIRE_STATUS_KEY.DEN_TUOI_NGHI_HUU, _searchObject);
        setColumns(canhBaoNhanSuDenTuoiNghiHuu(handleDecideToRetire));
        setCurrentDetail(VARIABLE_STRING.CANH_BAO_NHAN_SU_DEN_TUOI_NGHI_HUU);
        break;
      case VARIABLE_STRING.CANH_BAO_DEN_HAN_VAN_BANG_CHUNG_CHI:
        getCanhBao(getDataCanhBaoDenHanVanBangChungChi, EXPIRE_STATUS_KEY.DEN_HAN_VAN_BANG_CHUNG_CHI, _searchObject);
        setColumns(canhBaoDenHanVanBangChungChi());
        setCurrentDetail(VARIABLE_STRING.CANH_BAO_DEN_HAN_VAN_BANG_CHUNG_CHI);
        break;
      case VARIABLE_STRING.CANH_BAO_HET_HAN_LUAN_CHUYEN:
        getCanhBao(getDataCanhBaoHetHanLuanChuyen, EXPIRE_STATUS_KEY.HET_HAN_LUAN_CHUYEN, _searchObject);
        setColumns(canhBaoHetHanLuanChuyenColumn(handleAddTransition));
        setCurrentDetail(VARIABLE_STRING.CANH_BAO_HET_HAN_LUAN_CHUYEN);
        break;
      case VARIABLE_STRING.CANH_BAO_NANG_LUONG_TRUOC_HAN:
        getCanhBao(getDataCanhBaoNangLuongTruocHan, EXPIRE_STATUS_KEY.HET_HAN_NANG_LUONG_TRUOC_HAN, _searchObject);
        setColumns(canhBaoNangLuongTruocHanColumn(handleSalaryAheadOfTime));
        setCurrentDetail(VARIABLE_STRING.CANH_BAO_NANG_LUONG_TRUOC_HAN);
        break;
      case VARIABLE_STRING.CANH_BAO_HET_HAN_GIAN_DOAN:
        getCanhBao(getDataCanhBaoHetHanGianDoan, EXPIRE_STATUS_KEY.HET_HAN_GIAN_DOAN, _searchObject);
        setColumns(canhBaoHetHanGianDoanColumn());
        setCurrentDetail(VARIABLE_STRING.CANH_BAO_HET_HAN_GIAN_DOAN);
        break;
      case VARIABLE_STRING.CANH_BAO_HET_HAN_CU_DAO_TAO:
        getCanhBao(getDataCanhBaoHetHanDaoTao, EXPIRE_STATUS_KEY.HET_HAN_DAO_TAO, _searchObject);
        setColumns(canhBaoHetHanCuDaoTaoColumn(handleAddCertificate));
        setCurrentDetail(VARIABLE_STRING.CANH_BAO_HET_HAN_CU_DAO_TAO);
        break;
      default:
        setDataWarningDetails([]);
        setCurrentDetail("");
        break;
    }
    setTitle(title);
    setIsViewDetails(true);
  };

  const handleSelectData = (data: any) => {};

  const handleSetData = (data: any) => {};

  const handleCloseAdjustSalaryDialog = () => {
    setSalaryInfo({} as IAdjustSalary);
    setIsOpenAdjustSalaryDialog(false);
  };

  const handleCloseRetireDialog = () => {
    setRetireInfo({} as IRetireInfo);
    setIsOpenRetireDialog(false);
  };

  const handleCloseDetail = () => {
    const _searchObject = {
      ...searchObject,
      keyword: null
    };
    setSearchObject(_searchObject);
    setIsViewDetails(false);
    setDataWarningDetails([]);
    setTitle("");
    setCurrentDetail("");
    fetchDataWarning(_searchObject);
  };

  const handleSearch = () => {
    searchObject.keyword = searchObject?.keyword?.trim() || ""
    switch (currentDetail) {
      case VARIABLE_STRING.CANH_BAO_HET_HAN_HOP_DONG:
        getCanhBao(getDataCanhBaoHetHanHopDong, EXPIRE_STATUS_KEY.HET_HAN_HOP_DONG, searchObject);
        break;
      case VARIABLE_STRING.CANH_BAO_DEN_HAN_NANG_LUONG:
        getCanhBao(getDataCanhBaoHetHanNangLuong, EXPIRE_STATUS_KEY.DEN_HAN_NANG_LUONG, searchObject);
        break;
      case VARIABLE_STRING.CANH_BAO_NANG_LUONG_TRUOC_HAN:
        getCanhBao(getDataCanhBaoNangLuongTruocHan, EXPIRE_STATUS_KEY.HET_HAN_NANG_LUONG_TRUOC_HAN, searchObject);
        break;
      case VARIABLE_STRING.CANH_BAO_NHAN_SU_DEN_TUOI_NGHI_HUU:
        getCanhBao(getDataCanhBaoNhanSuDenTuoiNghiHuu, EXPIRE_STATUS_KEY.DEN_TUOI_NGHI_HUU, searchObject);
        break;
      case VARIABLE_STRING.CANH_BAO_DEN_HAN_VAN_BANG_CHUNG_CHI:
        getCanhBao(getDataCanhBaoDenHanVanBangChungChi, EXPIRE_STATUS_KEY.DEN_HAN_VAN_BANG_CHUNG_CHI, searchObject);
        break;
      case VARIABLE_STRING.CANH_BAO_HET_HAN_LUAN_CHUYEN:
        getCanhBao(getDataCanhBaoHetHanLuanChuyen, EXPIRE_STATUS_KEY.HET_HAN_LUAN_CHUYEN, searchObject);
        break;
      case VARIABLE_STRING.CANH_BAO_HET_HAN_GIAN_DOAN:
        getCanhBao(getDataCanhBaoHetHanGianDoan, EXPIRE_STATUS_KEY.HET_HAN_GIAN_DOAN, searchObject);
        break;
      case VARIABLE_STRING.CANH_BAO_HET_HAN_CU_DAO_TAO:
        getCanhBao(getDataCanhBaoHetHanDaoTao, EXPIRE_STATUS_KEY.HET_HAN_DAO_TAO, searchObject);
        break;
      default:
        fetchDataWarning(searchObject);
        break;
    }
  }

  const handleChangeSelect = (name: string, value: any) => {
    setSearchObject({
      ...searchObject,
      [name]: value
    });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSearchObject({
      ...searchObject,
      [name]: value
    });
  }

  return (
    <div className="wrapper">
      <div className="spaces flex justify-content-between align-items-center mt-16">
        <h2 className="breadcrumb-title">{`${lang("GENERAL.WARNING.INFO")}${title ? ` / ${title}` : ""}`}</h2>
        <div className="flex gap-4 align-self-end">
          <div className="mr-2 warning-input-search">
            <InputSearch
              className="border-3px"
              name="keyword"
              value={searchObject.keyword || ""}
              placeholder={currentDetail ? "Tìm kiếm theo mã nhân viên, họ tên" : "Tìm kiếm theo tên cảnh báo"}
              isEnter={true}
              handleSearch={handleSearch}
              handleChange={handleChange}
            />
          </div>
          <GroupButton handleEvent={handleSearch}>
            {lang("BTN.SEARCH")}
          </GroupButton>
        </div>
      </div>
      <div className="content-wrapper">
        <Row className="search-area">
          <Col xs={7} xxl={6} className="warning-info">
            {isViewDetails && (
              <GroupButton className="pb-2 color-primary" type="btn-back" handleClose={handleCloseDetail} />
            )}
            <Row className="align-items-end pb-4">
              <Col xs={4} md={5} className="spaces z-index-2">
                <Autocomplete
                  lable={lang("WARNING.UNIT")}
                  options={[]}
                  value={searchObject.donVi || null}
                  name="donVi"
                  onChange={(value) => handleChangeSelect(VARIABLE_STRING.DON_VI, value)}
                  searchFunction={searchListWorkUnit}
                />
              </Col>
              <Col
                xs={4}
                md={3}
              >
                <TextValidator
                  lable={lang("WARNING.TO_DATE")}
                  name="requestDate"
                  value={searchObject.requestDate || moment().format("YYYY-MM-DD")}
                  type="date"
                  onChange={handleChange}
                />
              </Col>
              <Col
                xs={4}
                md={4}
                className=""
              >
                <GroupButton handleEvent={handleSearch}>
                  {lang("WARNING.UPDATE")}
                </GroupButton>
              </Col>
            </Row>
          </Col>
          <Col xs={5} xxl={6} className="advance-search flex justify-content-end align-items-end pb-4">
            {!isViewDetails && (
              <GroupButton className="spaces mt-10" outline handleEvent={() => setIsViewAll(!isViewAll)}>
                {`${isViewAll ? 'Thu gọn' : 'Hiển thị tất cả'}`}
              </GroupButton>
            )}
          </Col>
        </Row>
        {!isViewDetails ? (
          <Row className="warning">
            {listWarning?.map((item: IWarning, index: number) => (
              <Col
                key={index}
                xxl={4}
                xl={6}
                lg={6}
                md={12}
                className="spaces p-12"
                onClick={() => handleOpenDetails(item?.id, item?.title)}
              >
                <WarningChart data={item} />
              </Col>
            ))}
          </Row>
        ) : (
          <>
            <Row>
              <TableCollapseCustom
                columnNameList={columns}
                data={dataWarningDetails}
                nameParent="phongBan"
                nameChildren="data"
                isSelect
                noToolbar
                selectData={handleSelectData}
                setData={handleSetData}
                selectionMode="multiple"
              />
            </Row>
          </>
        )}
      </div>
      {isOpenAdjustSalaryDialog && (
        <AdjustSalaryDialog
          handleClose={handleCloseAdjustSalaryDialog}
          salaryInfo={salaryInfo}
          handleUpdateParent={() => getCanhBao(getDataCanhBaoHetHanNangLuong, EXPIRE_STATUS_KEY.DEN_HAN_NANG_LUONG)}
        />
      )}
      {isOpenRetireDialog && (
        <RetireDecisionDialog
          handleClose={handleCloseRetireDialog}
          retireInfo={retireInfo}
          handleUpdateParent={() => getCanhBao(getDataCanhBaoNhanSuDenTuoiNghiHuu, EXPIRE_STATUS_KEY.DEN_TUOI_NGHI_HUU)}
        />
      )}

      {isOpenAddContractDialog && (
        <ContractDialog
          isView={false}
          handleCloseContractDialog={() => setIsOpenAddContractDialog(false)}
          handleCloseAndSearch={() => {
            setIsOpenAddContractDialog(false);
            getCanhBao(getDataCanhBaoHetHanHopDong, EXPIRE_STATUS_KEY.HET_HAN_HOP_DONG);
          }}
          shouldOpenContractDialog={isOpenAddContractDialog}
          employeeInfo={employeeInfo}
          contractEdit={initContract}
          isReSignContract={true}
          warningInfo={curWarningInfo}
        />
      )}

      {isOpenEndContractDialog && (
        <EndContractDialog
          open={isOpenEndContractDialog}
          handleClose={() => setIsOpenEndContractDialog(false)}
          isView={false}
          resignInfo={endResignInfo}
          warningInfo={curWarningInfo}
          handleReload={() => getCanhBao(getDataCanhBaoHetHanHopDong, EXPIRE_STATUS_KEY.HET_HAN_HOP_DONG)}
        />
      )}

      {isOpenTransitionDialog && (
        <TransitionWarningDialog
          open={isOpenTransitionDialog}
          handleClose={() => setIsOpenTransitionDialog(false)}
          isView={false}
          transferInfo={{} as TransitionInFo}
          handleReload={() => getCanhBao(getDataCanhBaoHetHanLuanChuyen, EXPIRE_STATUS_KEY.HET_HAN_LUAN_CHUYEN)}
          warningInfo={curWarningInfo}
        />
      )}

      {isOpenSalaryAheadOfTimeDialog && (
        <SalaryAheadOfTimeDialog
          handleClose={handleCloseSalaryAheadOfTimeDialog}
          salaryInfo={salaryInfo}
          handleUpdateParent={() => getCanhBao(getDataCanhBaoNangLuongTruocHan, EXPIRE_STATUS_KEY.HET_HAN_NANG_LUONG_TRUOC_HAN)}
        />
      )}

      {isOpenCertificateDialog && (
        <CertificateTrainingDialog
          handleCloseDialog={() => setIsOpenCertificateDialog(false)}
          handleCloseAndSearch={() => {
            setIsOpenCertificateDialog(false);
            getCanhBao(getDataCanhBaoHetHanDaoTao, EXPIRE_STATUS_KEY.HET_HAN_DAO_TAO);
          }}
          sendPeopleInfo={curWarningInfo}
        />
      )}
    </div>
  );
}

export default Warning;
